package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimAndMakafUseCase
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import com.eladfinish.bible.contest.utils.getOtiot
import io.github.aakira.napier.Napier
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import kotlin.math.abs

/**
 * Developed by
 * @author Elad Finish
 */

class ConsecutiveVersesWithSameNumberOfLetters(
    private val includeLog: Boolean = false,
) : SpecialSearch,
    KoinComponent {

    private val sb = StringBuilder()

    private var lengths = mutableListOf<Pair<Int, String>>()

    private val removeNikudAndTeamimAndMakafUseCase by inject<RemoveNikudAndTeamimAndMakafUseCase>()

    override fun process(chapterDetails: ChapterDetails) = with(chapterDetails) {
        verses.forEachIndexed { index, verse ->
            verse.trim().let {
                val onlyLetters = removeNikudAndTeamimAndMakafUseCase(it).replace(StringConstants.COLON_SPLITTER, "")
                    .replace(" ", "")

//                if (
//                        (bookName == "תהילים" && chapterName == "פט")
//                        || (bookName == "תהילים" && chapterName == "קיט")
//                        || (bookName == "משלי" && chapterName == "יג")
//                        || (bookName == "איוב" && chapterName == "טו")
//                        || (bookName == "איוב" && chapterName == "כו")
//                        || (bookName == "איכה" && chapterName == "ג")
//                ) {
//                    Napier.d("onlyLetters_aa %s", onlyLetters.chunked(1))
//                    Napier.d("onlyLetters_tt %s %s, %s\t%s", bookName, chapterName,
//                            getOtiot(index.plus(1)), onlyLetters.chunked(1).joinToString(separator = "\t"))
//                }
//                Napier.d("onlyLetters_ $onlyLetters")

                lengths.add(
                    onlyLetters.length to
                            "(".plus(bookName).plus(" ").plus(chapterName).plus(", ")
                                .plus(getOtiot(index.plus(1)))
                                .plus(")")
                )
            }
        }

        if (includeLog) {
            sb.append(bookName).append(" ")
                .append(chapterName).append(" - ")
                .append(verses.size).append(" פסוקים ")
                .append("\n")
        }
    }

    override fun getSummary(): String {
        return sb.apply {
            if (includeLog) {
                append("\n@@@\n")
            }

            val myList = lengths.mapIndexed { index, pair ->
                Triple(index, pair.first, pair.second)
            }

            val compress1 = myList.compress()
//            val compress1 = lengths.compress()

//            Napier.d("compress_1_\n${compress1.joinToString(separator = "\n")}")
//            Napier.d("compress_1_ ${compress1.size}")

            val compress2 = compress1.compress()

//            Napier.d("compress_2_\n${compress2.joinToString(separator = "\n")}")
//            Napier.d("compress_2_ ${compress2.size}")

            val compress3 = compress2.compress()
                .also { list ->
                    Napier.d(
                        "compress_3_\n${
                        list.withIndex()
                            .joinToString(separator = "\n") {
                                ("${it.index.plus(1)}) ").plus(
                                    "${it.value.second} ".plus("אותיות").plus(":\n")
                                        .plus(it.value.third)
                                )
                            }
                    }")
                }

            compress3.compress()
                .also {
                    Napier.d(
                        "compress_4_\n${
                            it.joinToString(separator = "\n")
                        }"
                    )
                }

//            val compress3 = compress2.zipWithNext().filter { abs(it.first.first - it.second.first) == 1 }
//                    .joinToString(separator = "\n")
//                    .also {
//                        Napier.d("compress_3_\n$it")
//                    }

            append("פסוקים ומספר אותיותיהם").append("\n")
                .append(
                    compress2
                        .withIndex()
                        .joinToString(separator = "\n") {
                            ("${it.index.plus(1)}) ").plus(
                                "${it.value.second} ".plus("אותיות").plus(":\n")
                                    .plus(it.value.third)
                            )
                        })

                .append("\n\n---------------\n\n")
                .append(
                    compress3
                        .withIndex()
                        .joinToString(separator = "\n") {
                            ("${it.index.plus(1)}) ").plus(
                                "${it.value.second} ".plus("אותיות").plus(":\n")
                                    .plus(it.value.third)
                            )
                        })
//                            {("${it.index}) ").plus(it.second.toString().plus(" אותיות").plus(":\n").plus(it.third)) })

        }.toString()
    }

}


//--------------//index, letters, T
fun <T> List<Triple<Int, Int, T>>.compress(): List<Triple<Int, Int, Set<T>>> =
    when (isEmpty()) {
        true -> listOf()
        else -> zipWithNext().filter { abs(it.first.first - it.second.first) == 1 && it.first.second == it.second.second }
            .map {
                Triple(
                    it.first.first,
                    it.first.second,
                    if (it.first.third is Set<*> && it.second.third is Set<*>) {
                        @Suppress("UNCHECKED_CAST")
                        listOf((it.first.third as Set<*>).toList(), (it.second.third as Set<*>).toList()).flatten().toSet() as Set<T>
                    } else {
                        setOf(it.first.third, it.second.third)
                    }
                )
            }
    }
